import { mmFetchWithResponse } from '../mmFetchWithResponse';

const littleSpoonInventoryApi = {
    /**
     * Fetch the Little Spoon inventory and cover payload. Counts only; every rate,
     * cover figure and reorder point is derived client-side.
     */
    getInventory: async ({ signal } = {}) =>
        mmFetchWithResponse('api/fbm/v1/littlespoon/inventory', { method: 'GET', signal }),
};

export { littleSpoonInventoryApi };
